// extracted by mini-css-extract-plugin
export default {"textStandout":"textStandout-oYim5","loadingPlaceholder":"loadingPlaceholder-jBNvp","availabilityBox":"availabilityBox-Y9lOt","priceText":"priceText-J5QoN"};